import { Collapse, Flex, Table } from 'antd';

const columns = [
    {
        title: 'Loại',
        dataIndex: 'title',
        key: 'title',
    },
    {
        title: 'Tham số',
        dataIndex: 'parameter',
        key: 'parameter',
    },
    {
        title: 'Kiểu dữ liệu',
        dataIndex: 'type',
        key: 'type',
    },
    {
        title: 'Mô tả',
        dataIndex: 'description',
        key: 'description',
    },
];

const dataSource = [
    {
        title: 'Body JSON',
        parameter: 'order_id',
        type: 'Number | String',
        description: 'ID đơn website muốn gia hạn',
    },
    {
        title: 'Body JSON',
        parameter: 'pricing_id',
        type: 'Number | String',
        description: 'ID chu kỳ website muốn gia hạn',
    },
];

const example = {
    order_id: 19777564,
    pricing_id: 43987063,
};

const responseSuccess = {
    data: {
        template: {
            id: 23176528,
            title: 'Web clone trang nạp thẻ của Garena',
        },
        cloudflare: {
            name: 'test.com',
            status: 'pending',
            name_servers: ['lennon.ns.cloudflare.com', 'love.ns.cloudflare.com'],
            original_name_servers: ['ns1.safesecureweb.com', 'ns2.safesecureweb.com', 'ns3.safesecureweb.com'],
        },
        id: 19777564,
        auto_renew: false,
        status: 'confirming',
        app_domain: 'test.com',
        email_admin: 'test.com@thegioicode.com',
        description: 'Vui lòng trỏ Nameservers gốc về Nameservers mới của chúng tôi!',
        admin_domain: 'admin.test.com',
        password_admin: 'ktC7AI9t#Y#K',
        created_at: '2025-05-19 21:06:16',
        expired_at: '2025-09-19 23:59:59',
    },
    status: 200,
    message: 'Gia hạn đơn tạo website thành công',
};

function Renew() {
    return (
        <Collapse
            items={[
                {
                    key: '1',
                    label: <div className="font-bold text-hover">Gia hạn website</div>,
                    children: (
                        <div>
                            <Flex align="center">
                                <span className="document-method text-warning font-bold">POST</span>
                                <span className="document-method flex-1 text-start">https://thegioicode.com/api/v2/templates/renew</span>
                            </Flex>

                            <Table className="mt-4" bordered columns={columns} dataSource={dataSource} pagination={false} />

                            <div className="mt-3 mb-1">Body:</div>
                            <div>
                                <div className="copy">
                                    <pre>
                                        <code className="text-copy warning">{JSON.stringify(example, null, 2)}</code>
                                    </pre>
                                </div>
                            </div>

                            <div className="mt-3 mb-1">Thành công:</div>
                            <div>
                                <div className="copy">
                                    <pre>
                                        <code className="text-copy success">{JSON.stringify(responseSuccess, null, 2)}</code>
                                    </pre>
                                </div>
                            </div>

                            <div className="mt-3 mb-1">Thất bại:</div>
                            <div>
                                <div className="copy">
                                    <pre>
                                        <code className="text-copy">
                                            {JSON.stringify({ status: 'Mã code lỗi', error: 'Thông tin lỗi trả về' }, null, 4)}
                                        </code>
                                    </pre>
                                </div>
                            </div>
                        </div>
                    ),
                },
            ]}
        />
    );
}

export default Renew;
